import { z } from 'zod';
import { LEGACY_MAP_STYLE_ALIASES, MAP_STYLE_IDS, normalizeMapStyle } from './map-style.js';

/** Canonical map IDs for new edits, with explicit support for older saved configurations. */
export const MapStyleSchema = z.enum([...MAP_STYLE_IDS, ...Object.keys(LEGACY_MAP_STYLE_ALIASES)])
  .transform(value => normalizeMapStyle(value)!);
